//import logo from './logo.svg';
//import './App.css';

import { useEffect, useState } from 'react'
import { startOfWeek , endOfWeek , add , sub , format} from 'date-fns'
import { nlBE } from 'date-fns/locale'

function Openingsuren() {
	const api = "https://lib.arteveldehogeschool.be/mediatheken/lib/openingsuren/v2/api.php"
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

  const firstDayOfTheWeek = (dateObject, firstDayOfWeekIndex) => {

    const dayOfWeek = dateObject.getDay(),
  firstDay = new Date(dateObject),
  diff = dayOfWeek >= firstDayOfWeekIndex ?
  dayOfWeek - firstDayOfWeekIndex :
    6 - dayOfWeek;

    firstDay.setDate(dateObject.getDate() - diff);
    firstDay.setHours(0, 0, 0, 0);

    return firstDay;
}

  const lastDayOfTheWeek = (dateObject, lastDayOfWeekIndex) => {
    const dayOfWeek = dateObject.getDay(),
    lastDay = new Date(dateObject),
    diff = (lastDayOfWeekIndex + (7 - dateObject.getDay())) % 7;
    lastDay.setDate(dateObject.getDate() + diff);
    lastDay.setHours(0, 0, 0, 0);
    return lastDay;
  }

  const formatDate = (d) => {
    return [
      d.getFullYear(),
      ('0' + (d.getMonth() + 1)).slice(-2),
      ('0' + d.getDate()).slice(-2)
    ].join('-');
  }

  const localeStrings = {
      nl : {
        deze_week : "Huidige week" ,
        mediatheek : "Mediatheek" ,
        gesloten : "Gesloten" ,
        vorige_week : "Vorige week",
        volgende_week : "Volgende week"
      } ,
      en : {
        deze_week : "Current week" ,
        mediatheek : "Library" ,
        gesloten : "Closed" ,
        vorige_week : "Previous week",
        volgende_week : "Next week"
      }
  } 
  const locales = Object.keys(localeStrings)
  const c = urlParams.get('campus') ? urlParams.get('campus') : 'kat,knt,mar,sab,sap'
  const l = urlParams.get('locale') ? locales.includes(urlParams.get('locale')) ? urlParams.get('locale') : 'nl' : 'nl'
  const [ useDates, setUseDates ] = useState({
    first : startOfWeek(new Date(), { weekStartsOn : 1 , locale : nlBE }) ,
    last : endOfWeek(new Date(), { weekStartsOn : 1  , locale : nlBE }) 
  }) 
  
  const addOneWeek = () => {
    let d = useDates.first
    let nW = add(d, { weeks : 1})
    setUseDates({
      first : startOfWeek(nW, { weekStartsOn : 1 , locale : 'nl-BE' }) ,
      last : endOfWeek(nW, { weekStartsOn : 1 , locale : 'nl-BE' })     
    })
  }

  const subOneWeek = () => {
    let d = useDates.first
    let nW = sub(d, { weeks : 1})
    setUseDates({
      first : startOfWeek(nW, { weekStartsOn : 1 , locale : 'nl-BE' }) ,
      last : endOfWeek(nW, { weekStartsOn : 1 , locale : 'nl-BE' })     
    })
  }

  const reset = () => {
    setUseDates({
      first : startOfWeek(new Date(), { weekStartsOn : 1 , locale : 'nl-BE' }) ,
      last : endOfWeek(new Date(), { weekStartsOn : 1 , locale : 'nl-BE'  }) 
    })
  }
  const [ openingsUren , setOpeningsUren ] = useState({})
  const [ campusList , setCampusList ] = useState([])
  useEffect(() => {
    console.log(`Call API`)
    const params = new URLSearchParams({
      campus: c,
      first: formatDate(useDates.first),
      last: formatDate(useDates.last),
      groupBy : 'campus'
    });

    const requestOptions = {
  		method: 'GET',
	  	redirect: 'follow'
	  };
	
	  const link = `${api}?${params.toString()}`
	  console.log(link)
	  fetch(link, requestOptions)
      .then(response => response.json())
      .then(result => {
          setCampusList(Object.keys(result))
          setOpeningsUren(result)
      })
      .catch(error => console.log('error', error));
  },[useDates])


  return (
    <div className="column column-2 theme--grey border--bottom border--transparent">
      { campusList.length > 0 &&
        campusList.map((c) => 
          <div className='calendar'>
            <table style={{width:'100%'}}>
              <thead>
              <tr>
                <th colSpan={2}><span onClick={() => reset()} title={localeStrings[l].deze_week} className='spanClick'>{`${localeStrings[l].mediatheek} ${c[0].toUpperCase()}${c.slice(1)}`}</span></th>
              </tr>
              <tr>
                <th><span onClick={() => subOneWeek()} title={localeStrings[l].vorige_week} className='spanClick'>&larr;</span></th>
                <th><span onClick={() => addOneWeek()} title={localeStrings[l].volgende_week} className='spanClick'>&rarr;</span></th>
              </tr>
              
              </thead>
              <tbody>
                {openingsUren[c].map((d) => {
                  if(d.type === 'normal') 
                  return(
                    <tr>
                      <td>{format(new Date(d.datum) , "dd-MM-yyyy")}</td>
                      <td>{[format(new Date(`${d.datum} ${d.open}`),'HH:mm'),format(new Date(`${d.datum} ${d.close}`),'HH:mm')].join('-')}</td>
                    </tr>)
                  return(
                    <tr>
                      <td>{format(new Date(d.datum) , "dd-MM-yyyy")}</td>
                      <td>{localeStrings[l].gesloten}</td>
                    </tr>)
                })}

              </tbody>
              
            </table>
          </div>
        )
      }
    </div>
  );
}

export default Openingsuren;
